'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//


exports.default = {

    props: ["info"],

    computed: {

        unitSymbol: function unitSymbol() {
            // TODO get temperature in dico of needed ?
            return this.info.unit === 'celsius' ? '°C' : ' F';
        }

    }

};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"presets":["es2015","stage-0"],"plugins":["transform-class-properties","transform-function-bind"]}!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/infos/temperature/TemperatureComponent.vue
// module id = 397
// module chunks = 0